import ContactForm from './ContactForm';

globalThis.ContactComponents = {
  ContactForm,
};
